import feedbacksReducer from "./feedbacksSlice";
import feedbackReducer from "./feedbackSlice";

const customers = {
  feedbacks: feedbacksReducer,
  feedback: feedbackReducer,
};

export default customers;
